import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNutanixComponent } from './simple-icons-nutanix.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNutanixComponent ],
    exports:      [ SimpleIconsNutanixComponent ],
    bootstrap:    []
})
export class SimpleIconsNutanixModule {}
